import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import Switch from "react-switch";

import { toast } from 'react-toastify';
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";
import ModalForm from "../../components/Modal/ModalForm";
import CustomModal from "../../components/Modal/CustomModal";

import { consultaPreferencias, GuardarAut, UpdAut, Guardar, AddPeriodo, DeletePeriodo, DeleteTmp } from "../../funciones/PreferenciasFunction";

import AutoridadesTable from "./PreferenciasContent/AutoridadesTable";

let cortesN = 1;
let datosAut = "";
let idPeriodo = "";
let mesPeriodo = "";
let yyyyPeriodo = "";

class Preferencias extends Component {
    state = {
        openDelPer: false,
        botonM1: {
            text: "Si",
            icon: "fa fa-check"
        },
        botonM2: {
            text: "No",
            icon: "fa fa-times"
        },
        boton1: {
            icon: "fa fa-spinner fa-spin",
            text: "Cargando Datos",
            disabled: true
        },
        boton2: {
            icon: "fa fa-spinner fa-spin",
            text: "Cargando Datos",
            disabled: true
        },
        boton3: {
            icon: "fa fa-spinner fa-spin",
            text: "Cargando Datos",
            disabled: true
        },
        boton4: {
            icon: "fa fa-spinner fa-spin",
            text: "Cargando Datos",
            disabled: true
        },
        boton5: {
            icon: "fa fa-spinner fa-spin",
            text: "Cargando Datos",
            disabled: true
        },
        addBtn: "Agregar",
        autoridades: [],
        textTabla: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando listado de Autoridades</React.Fragment>,
        valorC: { value: 1, label: "1 Corte de Notas"},
        valorMes: { value: 1, label: "Ene"},
        autTypes: [],
        valorAutTypes: {value:"", label: "- Selecciona un Tipo -"},
        prefData: [],
        openW: false,
        
        cedula:  { text:"", status: "" },
        nombre:  { text:"", status: "" },
        apellido:  { text:"", status: "" },

        cantErrores: "",
        cantErroresGral: "",

        preloader: {
            icon: "fa fa-spinner fa-spin",
            text: "Cargando Datos"
        },
        periodos: [],
        preloaderP: {
            icon: "fa fa-spinner fa-spin",
            text: "Cargando Datos"
        },
        iconTmp: "fa fa-trash"
    }
    
    constructor (props) {
        super (props)
        consultaPreferencias ((resp) => {
            cortesN = parseInt(resp[1].cortes)
            let vCorte = "";
            let textCorte = "";
            if (resp[3].length === 0) textCorte = "No existen periodos registrados";
            (cortesN === 1) ? vCorte = "Corte de Notas" : vCorte = "Cortes de Notas";
            

            let estate = {
                autoridades: resp[0],
                prefData: resp[1],
                autTypes: resp[2],
                periodos: resp[3],
                valorC: { value: cortesN, label: `${cortesN} ${vCorte}`},
                preloader: {
                    icon: "fa fa-institution",
                    text: "Datos de la Institución"
                },
                preloaderP: {
                    icon: "",
                    text: textCorte
                },
                boton1: {
                    icon: "fa fa-plus",
                    text: "Agregar",
                    disabled: false
                },
                boton2: {
                    icon: "fa fa-save",
                    text: "Guardar Cambios",
                    disabled: false
                },
                boton3: {
                    icon: "fa fa-save",
                    text: "Agregar Autoridad",
                    disabled: false
                },
                boton4: {
                    icon: "fa fa-edit",
                    text: "Modificar Datos",
                    disabled: false
                },
                boton5: {
                    icon: "fa fa-save",
                    text: "Guardar el Periodo",
                    disabled: false
                },
                periodoY: "",
            }
            let Na = {textTabla: "No existen autoridades educativas registradas",}

            if (resp[0] === 0){
                this.setState(
                    estate,
                    Na
                )
            }else{
                this.setState(estate)
            }
        })
    }

    valorSelectC = (valorC) => {
        cortesN = valorC.value

        let { prefData } = this.state;
        let contenido = prefData;

        for (let i in contenido) {
            if (i === "cortes") contenido[i] = valorC.value
        }

        this.setState({
            openDelPer: false,
            prefData: contenido,
            valorC
        })
    }

    valorSelectMes = (valorMes) => {
        this.setState({
            openDelPer: false,
            valorMes
        })
    }

    valorSelectAut = (valorAutTypes) => {
        this.setState({
            openDelPer: false,
            valorAutTypes
        })
    }

    valorCarrera = (valorCarrera) => {
        this.setState({
            valorCarrera
        })
    }

    cambiaText = (prop) => (e) => {
        this.setState({
            openDelPer: false,
            [prop]:{
                text:(e.target.value).toUpperCase(),
                status: "",
            },
        })
    }

    cambiaTextSimple = (prop) => (e) => {
        this.setState({
            openDelPer: false,
            [prop]: (e.target.value).toUpperCase(),
        })
    }

    cambiaValor = (prop) => (e) => {
        let { prefData } = this.state;
        let contenido = prefData;

        for (let i in contenido) {
            if (i === prop) contenido[i] = e.target.value 
        }

        this.setState({
            openDelPer: false,
            prefData: contenido 
        });  
    }

    cambiacheck = (prop) => (e) => {
        let { prefData } = this.state;
        let contenido = prefData;

        for (let i in contenido) {
            if (i === prop){
                (contenido[i] === 0) ? contenido[i] = 1 : contenido[i] = 0;
            } 
        }

        this.setState({
            openDelPer: false,
            prefData: contenido 
        });
    }

    cambiaList = (valor) => (e) => {
        let { prefData } = this.state;
        let contenido = prefData;

        for (let i in contenido) {
            if (i === "order_by") contenido[i] = valor 
        }

        this.setState({
            openDelPer: false,
            prefData: contenido 
        });
    }

    cerrarModal = () => {
        datosAut = ""
        this.setState ({
            contentErr: "",
            cedula:  { text:"", status: "" },
            nombre:  { text:"", status: "" },
            apellido:  { text:"", status: "" },
            valorAutTypes: {value:"", label: "- Selecciona un Tipo -"},
            openW: false,
            openDelPer: false,
        })
    }

    editModal = (data) => {
        datosAut = data.id;
        this.setState({
            cedula:  { text: data.ci, status: "" },
            nombre:  { text: data.nombre, status: "" },
            apellido:  { text: data.apellido, status: "" },
            valorAutTypes: {value: data.tipo, label: data.tname},
            openW: true,
        })
    }

    respuestaGuardarAut = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];
        
        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let respOk = (mensaje) => {
            consultaPreferencias ((resp) => {
                this.setState({
                    autoridades: resp[0],
                })
            })

            this.setState({
                boton3: {
                    icon: "fa fa-save",
                    text: "Agregar Autoridad"
                },
                boton4: {
                    icon: "fa fa-edit",
                    text: "Modificar Datos"
                }
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) {
            this.cerrarModal()
            this.setState({ cantErrores:"" })
        }
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        respOk(mensaje[0]);
    }

    modal = () => {
        const { openW, autTypes, cantErrores, valorAutTypes, boton3, boton4, cedula, nombre, apellido } = this.state;
        const camposForm = { cedula, nombre, apellido, valorAutTypes }

        let contenidoModal = () => {

            let campos = () => (
                <React.Fragment>
                    <Row className="custom-mt-10">
                        <Col md={5}>
                            <input className="form-control" value={cedula.text} onChange={this.cambiaText("cedula")} placeholder="Ej.: V0000000"/>
                            <span style={{fontSize: 11}} className="text-muted">*Cédula</span>
                        </Col>
                    </Row>
                    <Row className="custom-mt-10">
                        <Col md={4}>
                            <input className="form-control" value={nombre.text} onChange={this.cambiaText("nombre")} placeholder="Ingresa el Nombre"/>
                            <span style={{fontSize: 11}} className="text-muted">*Nombre</span>
                        </Col>
                        <Col md={4}>
                            <input className="form-control" value={apellido.text} onChange={this.cambiaText("apellido")} placeholder="Ingresa el Apellido"/>
                            <span style={{fontSize: 11}} className="text-muted">*Apellido</span>
                        </Col>
                        <Col md={4}>
                            <Select
                                isSearchable = {true}
                                value = {valorAutTypes}
                                onChange = {this.valorSelectAut}
                                options = { autTypes }
                            />
                            <span style={{fontSize: 11}} className="text-muted">*Tipo de Autoridad</span>
                        </Col>
                    </Row>
                </React.Fragment>
            )

            if (datosAut === "") return (
                <React.Fragment>
                    <div className="custom-alert-success">Completa los campos para Agregar una nueva Autoridad Educativa</div>
                    {campos()}
                    <Row>
                        <Col md ={7} className="custom-mt-20"><div className="text-danger">{ cantErrores }</div></Col>
                        <Col md={5} className="custom-mt-20" align="right">
                            <button className="btn btn-primary" disabled={boton3.disabled} style={{borderWidth: 1}} onClick={ (e) => {
                                    this.setState({
                                        boton3:{ icon: "fa fa-spinner fa-spin", text: "Espera por Favor" }
                                    }, () => {
                                        GuardarAut (camposForm, (resp) => { this.respuestaGuardarAut(resp) })
                                    })
                            }}><i className={boton3.icon}></i> {boton3.text}</button>
                        </Col>
                    </Row>
                </React.Fragment>
            )

            return (
                <React.Fragment>
                    <div className="custom-alert-success">Completa los campos que deseas actualizar y presiona el botón <strong>Modificar</strong></div>
                    {campos()}
                    <Row>
                        <Col md ={7} className="custom-mt-20"><div className="text-danger">{ cantErrores }</div></Col>
                        <Col md={5} className="custom-mt-20" align="right">
                            <button className="btn btn-warning" disabled={boton4.disabled} style={{borderWidth: 1}} onClick={ (e) => {
                                    this.setState({
                                        boton4:{ icon: "fa fa-spinner fa-spin", text: "Espera por Favor" }
                                    }, () => {
                                        UpdAut (datosAut, camposForm, (resp) => { this.respuestaGuardarAut(resp) })
                                    })
                            }}><i className={boton4.icon}></i> {boton4.text}</button>
                        </Col>
                    </Row>
                </React.Fragment>
            )
        }
        
        return (
            <ModalForm
                isopen =  {openW}
                titulo = {<div>Agregar o Editar Autoridades Educativas</div>}
                contenido = {contenidoModal()}
                cerrar = {this.cerrarModal}
            />
        );
    }

    lisAutoridades = () => {
        let { autoridades, textTabla } = this.state;
        if(autoridades.length === 0) {
            return (
                <tr>
                    <td colSpan={4} align="center">{textTabla}</td>
                </tr> 
            )
        }
        
        return(
            autoridades.map(option => (
                <AutoridadesTable
                key={option.id}
                data={option}
                funcion = {(data) => { this.editModal(data) }}
                funcion2 = {() => { consultaPreferencias ((resp) => {
                    this.setState({
                        autoridades: resp[0],
                    })
                })}}
                />
            ))
        )
    }

    cortes = () => {
        let { prefData } = this.state;

        let contenido = []
        if (cortesN === 0) return (<div>No se han seleccionado cortes todavía</div>)
        for (let i = 0; i < cortesN; i++){
            
            contenido.push (
                <Col md={4}>
                    <div style={{fontSize: 12}}>Ociones de {`Corte ${i + 1}`}</div>
                    <Row>
                        <Col md={6}>
                            <input className="form-control" value={prefData[`p_corte_${i + 1}`]} onChange={this.cambiaValor(`p_corte_${i + 1}`)} placeholder={`Corte ${i + 1}`} title="Indica el porcentaje (%) de la calificación correspondiente a este corte de notas"/>
                            <span style={{fontSize: 11}} className="text-muted">Porcentaje</span>
                        </Col>
                        <Col md={6}>
                            <input className="form-control" value={prefData[`col_p_corte_${i + 1}`]} onChange={this.cambiaValor(`col_p_corte_${i + 1}`)} placeholder="Columna" title="Especifica la letra de la columna del archivo .Xls para este corte"/>
                            <span style={{fontSize: 11}} className="text-muted">Columna</span>
                        </Col>
                    </Row>
                </Col>
            )
        }

        return contenido;
    }

    cortesHab = () => {
        let { prefData } = this.state;
        let contenido = []

        let statusCheck = (valor) => {
            let respuesta = true;
            if (valor === 0 || valor === false) respuesta = false;
            return respuesta;
        }

        if (cortesN === 0) return (<div>No se han seleccionado cortes todavía</div>)
        for (let i = 0; i < cortesN; i++){

            contenido.push (
                <Col md={2}>
                    <Switch height={12} width={24} /* onColor="#bf4747" */
                        onChange={this.cambiacheck(`hab_corte_${i + 1}`)}
                        checked={statusCheck(prefData[`hab_corte_${i + 1}`])}
                    />
                    {` Corte ${i + 1}`}
                </Col>
            )
        }
        
        return contenido;
    }

    respuestaGuardar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];

        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let RespOk = (mensaje) => {

            if (mensaje.status !== "error") consultaPreferencias ((resp) => {
                cortesN = parseInt(resp[1].cortes)
                let vCorte = "";

                (cortesN === 1) ? vCorte = "Corte de Notas" : vCorte = "Cortes de Notas";
                this.setState({
                    prefData: resp[1],
                    valorC: { value: cortesN, label: `${cortesN} ${vCorte}`},
                })
            })
            
            this.setState({
                boton2: {
                    icon: "fa fa-save",
                    text: "Guardar Cambios",
                    disabled: false
                }
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) {
            this.setState({ cantErroresGral:"" })
        }

        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErroresGral: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        RespOk(mensaje[0]);
    }

    openDelPediodo = (id, mes, yyyy) => () => {
        idPeriodo = id;
        mesPeriodo = mes;
        yyyyPeriodo = yyyy;
        this.setState({
            openDelPer: true
        })
    }

    delPeriodo = () => {
        let  { botonM1, botonM2 } = this.state;

        let mes = (num) => {
            let meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
            
            return meses[num - 1]
        }

        let contenidoModal = <div>
            ¿Desea realmente eliminar el <strong className="text-danger">{`Periodo ${mes(mesPeriodo)} ${yyyyPeriodo}`}</strong> del Sistema?
            <div><strong>Esta opción puede ocacionar fallas al sistema y no puede deshacerse</strong></div>
            </div>

            return (
                <CustomModal
                    isopen =  {this.state.openDelPer}
                    titulo = {<div className="text-primary">Confirmación</div>}
                    contenido = {contenidoModal}
                    boton1 = {<React.Fragment><i className= {botonM1.icon}></i> {botonM1.text}</React.Fragment>}
                    boton2 = {<React.Fragment><i className= {botonM2.icon}></i> {botonM2.text}</React.Fragment>}
                    funcion1 = {() => { 
                        this.setState({
                            botonM1: {
                                text: "Espera",
                                icon: "fa fa-spinner fa-spin"
                            }
                        }, () => {
                            DeletePeriodo(idPeriodo, (resp) => {
                                if (resp.status === "Warning") {
                                    toast.warning(resp.mess, {autoClose: 6000});
                                    this.setState({
                                        botonM1: {
                                            text: "Si",
                                            icon: "fa fa-check"
                                        },
                                        openDelPer: false
                                    })
                                }else{
                                    consultaPreferencias ((resp) => {
                                        let textCorte = "";
                                        if (resp[3].length === 0) textCorte = "No existen periodos registrados";
                                        
                                        let estate = {
                                            periodos: resp[3],
                                            valorMes: { value: 1, label: "Ene"},
                                            periodoY: "",
                                            preloaderP: {
                                                icon: "",
                                                text: textCorte
                                            },
                                            boton5: {
                                                icon: "fa fa-save",
                                                text: "Guardar el Periodo",
                                                disabled: false
                                            },
                                            botonM1: {
                                                text: "Si",
                                                icon: "fa fa-check"
                                            },
                                            openDelPer: false
                                        }
                            
                                        this.setState(estate)
                                        toast.info("El periodo ha sido eliminado exitósamente", {autoClose: 4000});
                                    })
                                }
                            })
                        })
                    }
                }/>
            );
    }

    periodos = () => {
        let { periodos, preloaderP } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let mes = (num) => {
            let meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
            
            return meses[num - 1]
        }
        
        if (periodos.length === 0) return (
            <tr>
                <td colSpan={3} align="center"><i className={preloaderP.icon}></i> {preloaderP.text}</td>
            </tr>
        )

        return (
            periodos.map(option => (
                <tr key= {option.id}>
                    <td align="center" style={styles}>{mes(option.corte_name)}</td>
                    <td align="center" style={styles}>{option.corte_year}</td>
                    <td align="center" style={styles}>
                        <button className="btn btn-danger btn-sm" onClick={this.openDelPediodo(option.id, option.corte_name, option.corte_year)} style={{borderWidth: 1}}><i className="fa fa-trash" title="Eliminar este periodo"></i></button>
                    </td>
                </tr>
            ))
        )
    }

    guardarPediodo = () => {
        let { valorMes, periodoY } = this.state;
        
        if (periodoY === ""){
            this.setState({
                boton5: {
                    icon: "fa fa-save",
                    text: "Guardar el Periodo",
                    disabled: false
                }
            })
            toast.error("Debes seleccionar el año del periodo",{autoClose: 4000});
            return null;
            
        }

        if (!isNaN(Number(periodoY)) === false){
            this.setState({
                boton5: {
                    icon: "fa fa-save",
                    text: "Guardar el Periodo",
                    disabled: false
                }
            })
            toast.error("El año debe contener solo números",{autoClose: 4000});
            this.setState({periodoY: ""})
            return null;
        }

        AddPeriodo (valorMes.value, periodoY, (re) => {
            if (re.status === "warning"){
                this.setState({
                    boton5: {
                        icon: "fa fa-save",
                        text: "Guardar el Periodo",
                        disabled: false
                    }
                }, () => {
                    toast.warning(re.mess, {autoClose: 4000});
                })
            }else{
                consultaPreferencias ((resp) => {
                
                    let textCorte = "";
                    if (resp[3].length === 0) textCorte = "No existen periodos registrados";
                    
                    let estate = {
                        periodos: resp[3],
                        valorMes: { value: 1, label: "Ene"},
                        periodoY: "",
                        preloaderP: {
                            icon: "",
                            text: textCorte
                        },
                        boton5: {
                            icon: "fa fa-save",
                            text: "Guardar el Periodo",
                            disabled: false
                        },
                    }
        
                    this.setState(estate)
                    toast.info("El periodo se añadió correctamente",{autoClose: 4000});
                })
            }
        })
    }

    delTmp = () => {
        this.setState({
            iconTmp: "fa fa-spinner fa-spin"
        }, () => {
            DeleteTmp(() => {
                this.setState({
                    iconTmp: "fa fa-trash"  
                }, () => {
                    toast.info("Los archivos temporales fueron eliminados exitósamente",{autoClose: 4000});
                })
            })
        })
    }

    contenido = () => {
        let { boton1, boton2, boton5, valorC, prefData, preloader, cantErroresGral, valorMes, periodoY, addBtn, iconTmp } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        const Cortes = [
            { value: 1, label: "1 Corte de Notas"},
            { value: 2, label: "2 Cortes de Notas"},
            { value: 3, label: "3 Cortes de Notas"},
            { value: 4, label: "4 Cortes de Notas"},
            { value: 5, label: "5 Cortes de Notas"},
        ]

        const Meses = [
            { value: 1, label: "Ene"},
            { value: 2, label: "Feb"},
            { value: 3, label: "Mar"},
            { value: 4, label: "Abr"},
            { value: 5, label: "May"},
            { value: 6, label: "Jun"},
            { value: 7, label: "Jul"},
            { value: 8, label: "Ago"},
            { value: 9, label: "Sep"},
            { value: 10, label: "Oct"},
            { value: 11, label: "Nov"},
            { value: 12, label: "Dic"},
        ]

        let ordenList = (opcion) => {
            switch (opcion) {
                case "listlistCi":
                    if (prefData.order_by === 0) return true;
                    return false
                case "listApe":
                    if (prefData.order_by === 1) return true;
                    return false
                default:
                    if (prefData.order_by === 0) return true;
                    return false
            } 
        }

        return (
            <React.Fragment>
                <div className="custom-alert-info" style={{padding: 5}}>
                    <div><i className={preloader.icon}></i> {preloader.text}</div>
                </div>
                <Row>
                    <Col md={12} className="custom-mt-10">
                        <input type="text" className="form-control" value={prefData.instituto} onChange={this.cambiaValor("instituto")} placeholder="Nombre del Intituto" title="Nombre de la Institución"/>
                        <span className="text-muted" style={{fontSize: 10}}>Nombre de la Institución</span>
                    </Col>
                    <Col md={4} className="custom-mt-10">
                        <input type="text" className="form-control" value={prefData.instituto_tlf1} onChange={this.cambiaValor("instituto_tlf1")} placeholder="Teléfono 1 de la Institución" title="Teléfono de la Institución"/>
                        <span className="text-muted" style={{fontSize: 10}}>Teléfono 1 de la Institución</span>
                    </Col>
                    <Col md={4} className="custom-mt-10">
                        <input type="text" className="form-control" value={prefData.instituto_tlf2} onChange={this.cambiaValor("instituto_tlf2")} placeholder="Teléfono 2 de la Institución" title="Teléfono de la Institución"/>
                        <span className="text-muted" style={{fontSize: 10}}>Teléfono 2 de la Institución</span>
                    </Col>
                    <Col md={4} className="custom-mt-10">
                        <input type="text" className="form-control" value={prefData.instituto_tlf3} onChange={this.cambiaValor("instituto_tlf3")} placeholder="Teléfono 3 de la Institución" title="Teléfono de la Institución"/>
                        <span className="text-muted" style={{fontSize: 10}}>Teléfono 3 de la Institución</span>
                    </Col>
                    <Col md={12}>
                        <textarea className="form-control" height={3} onChange={this.cambiaValor("instituto_dir")} placeholder="Direción de la Institución" value={prefData.instituto_dir}></textarea>
                        <span className="text-muted" style={{fontSize: 10}}>Direción de la Institución</span>
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        <input type="text" className="form-control" value={prefData.instituto_email} onChange={this.cambiaValor("instituto_email")} placeholder="Email del Plantel" title="Email de la Institución"/>
                        <span className="text-muted" style={{fontSize: 10}}>Email de la Institución</span>
                    </Col>
                </Row>

                <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>
                    <div><i className="fa fa-calendar"></i> Periodos Académicos</div>
                </div>
                <Row className="custom-mt-10">
                    <Col md={6}>
                        <div className="text-primary">Agregar un nuevo periodo</div>
                        <Row>
                            <Col md={6}>
                                <Select
                                    title = "Selecciona el mes"
                                    isSearchable = {true}
                                    value = {valorMes}
                                    onChange = {this.valorSelectMes}
                                    options = { Meses }
                                />
                                <span className="text-muted" style={{fontSize: 10}}>Mes del periodo</span>
                            </Col>
                            <Col md={6}>
                                <input type="text" value={periodoY} onChange={this.cambiaTextSimple("periodoY")} className="form-control" placeholder="AAAA"/>
                                <span className="text-muted" style={{fontSize: 10}}>Año del periodo</span>
                            </Col>
                            <Col md={12} className="custom-mt-10">
                            <button className="btn btn-primary" disabled={boton5.disabled} style={{borderWidth: 1}}
                                onClick={ (e) => {
                                    this.setState({
                                        boton5:{ icon: "fa fa-spinner fa-spin", text: "Espera por Favor" }
                                    }, () => {
                                        this.guardarPediodo()
                                })}}
                            ><i className={boton5.icon}></i> {boton5.text}</button>
                            </Col>
                        </Row>
                        </Col>
                    <Col md={6}>
                        <div className="text-primary" align="center">Periodos Académicos Registrados</div>
                        <div className="table-responsive" style={{backgroundColor:"#FFF", overflowY:"auto", height: "20vh", overflowX:"hidden"}}>
                            <Table striped hover bordered>
                                <tbody>
                                <tr className="custon-back-color">
                                    <td align="center" width="50%" style={styles}><strong>Nombre</strong></td>
                                    <td align="center" width="50%" style={styles}><strong>Año</strong></td>
                                    <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                {this.periodos()}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>

                
                <div className="custom-alert-success custom-mt-20" style={{padding: 5}}>
                    <Row>
                        <Col md={7}>
                            <div style={{marginTop: 10}}><i className="fa fa-graduation-cap"></i> Autoridades Educativas</div>
                        </Col>
                        <Col md={5} align="right">
                            <button className="btn btn-relleno-success" disabled={boton1.disabled} onClick ={() => { this.setState({openW: true, openDelPer: false,}) }} title="Agregar una Nueva Autoridad Educativa" style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                        </Col>
                    </Row>
                </div>

                <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowY:"auto", maxHeight: "40vh", overflowX:"hidden"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                <td width="50%" style={styles}><strong>Docente</strong></td>
                                <td width="35%" style={styles}><strong>Tipo</strong></td>
                                <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                            </tr>
                            {this.lisAutoridades()}
                        </tbody>
                    </Table>
                </div>

                <div className="custom-alert-warning custom-mt-10" style={{padding: 5}}>
                    <div><i className="fa fa-gear"></i> Configuraciones del Sistema</div>
                </div>
                
                <div className="text-danger custom-mt-10">
                    <i className="fa fa-eercast"></i> Configuraciones de Inscripción
                </div>

                <Row>
                    <Col md={3}>
                        <input className="form-control" value={prefData.min_uc} onChange={this.cambiaValor("min_uc")} placeholder="Min U.C" title="Mímimo de unidades de credito que el estudiante puede inscribir"/>
                        <span style={{fontSize: 9}} className="text-muted">Mínimo de Unidades de Cŕedito</span>
                    </Col>
                    <Col md={3}>
                        <input className="form-control" value={prefData.max_uc} onChange={this.cambiaValor("max_uc")} placeholder="Max U.C" title="Máximo de unidades de credito que el estudiante puede inscribir"/>
                        <span style={{fontSize: 9}} className="text-muted">Máximo de Unidades de Cŕedito</span>
                    </Col>
                    <Col md={3}>
                        <input className="form-control" value={prefData.min_mate} onChange={this.cambiaValor("min_mate")} placeholder="Min Mat." title="Mímimo de materias que el estudiante puede inscribir"/>
                        <span style={{fontSize: 9}} className="text-muted">Mínimo de Materias a Inscribir</span>
                    </Col>
                    <Col md={3}>
                        <input className="form-control" value={prefData.max_mate} onChange={this.cambiaValor("max_mate")} placeholder="Max Mat." title="Máximo de materias que el estudiante puede inscribir"/>
                        <span style={{fontSize: 9}} className="text-muted">Máximo de Materias a Inscribir</span>
                    </Col>
                </Row>

                <div className="text-danger custom-mt-10">
                    <i className="fa fa-eercast"></i> Configuraciones de la Evaluación
                </div>
                <div className="custom-alert-danger" style={{padding:5}}>
                    <Row>
                        <Col md={6}>
                            <div className="custom-mt-10">
                                <i className="fa fa-pie-chart"></i> Distribución del Porcentaje
                            </div>
                        </Col>
                        <Col md={6}>
                            <Select
                                title = "Selecciona la Cantidad"
                                isSearchable = {true}
                                value = {valorC}
                                onChange = {this.valorSelectC}
                                options = { Cortes }
                            />
                        </Col>
                    </Row>
                </div>
                <div className="custom-alert-danger" style={{padding:5, marginTop:2}}>    
                    <Row className="custom-mt-10">
                        {this.cortes()}
                    </Row>
                </div>
                <div className="custom-alert-danger" style={{padding:5, marginTop:2}}>
                    <div><i className="fa fa-check-circle"></i>Cortes de Nota Habilitados para los Profesores</div>
                    <Row className="custom-mt-10" align="center">
                        {this.cortesHab()}
                    </Row>
                </div>

                <div className="text-danger custom-mt-10">
                    <i className="fa fa-eercast"></i> Otras Configuraciones
                </div>

                <Row>
                    <Col md={8}>
                        <div className="custom-alert-danger" style={{padding:5, marginTop:2}}>
                            <Row>
                                <Col md={4}>
                                    <div style = {{fontSize: 10}}><i className="fa fa-list"></i>Ordenar Listados</div>
                                </Col>
                                <Col md={4} align="right">
                                    <Switch height={12} width={24} /* onColor="#bf4747" */ onChange={this.cambiaList(0)} checked={ordenList("listlistCi")} /> Por Cédula
                                </Col>
                                <Col md={4} align="right">
                                    <Switch height={12} width={24} /* onColor="#bf4747" */ onChange={this.cambiaList(1)} checked={ordenList("listApe")} /> Por Apellido
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="custom-alert-danger" style={{padding:5, marginTop:2}} align = "center">
                            <button className="btn btn-relleno-danger btn-xs" onClick = {this.delTmp} title = "Borrar archivos temporales" style={{borderWidth: 1}}><i className={iconTmp}></i> Borrar Temporales</button>
                        </div>
                    </Col>
                </Row>
                
                <Row>
                    <Col md ={7} className="custom-mt-20"><div className="text-danger">{ cantErroresGral }</div></Col>
                    <Col md={5} className="custom-mt-20" align="right">
                        <button className="btn btn-primary" disabled={boton2.disabled} style={{borderWidth: 1}}
                            onClick={ (e) => {
                                this.setState({
                                    boton2:{ icon: "fa fa-spinner fa-spin", text: "Espera por Favor" }
                                }, () => {
                                    Guardar (prefData, (resp) => { this.respuestaGuardar(resp) })
                            })}}
                        ><i className={boton2.icon}></i> {boton2.text}</button>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    cambiaCkeckP = () => {

    }

    ayuda = () => (
        <Row>
            <Col md ={12} align="justify">
                En este módulo puedes actualizar las configuraciones del sistema.
            </Col>
            <Col md ={12} align="justify" className="custom-mt-10">
                <div className="custom-alert-info"><i className="fa fa-institution"></i> Datos de la Institución</div>
                <div align="justify" className="custom-mt-10">
                    Todos estos campos son obligatorios, asegúrate que los datos suministrados sean correctos.
                </div>
                <div align="justify" className="custom-mt-10">
                    El campo <strong>Email de la Institución</strong> es el correo de contacto al que los usuarios pueden comunicarse.
                </div>
            </Col>
            <Col md ={12} align="justify" className="custom-mt-10">
                <div className="custom-alert-info"><i className="fa fa-calendar"></i> Periodos Académicos</div>
                <div align="justify" className="custom-mt-10">
                    Puedes agregar periodos académicos en esta opción tomando en cuenta los periodos disponibles. Para ello selecciona el mes y el año de cada periodo y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-save"></i> Guardar el Periodo</button>
                </div>
                <div align="justify" className="custom-mt-10">
                    No puedes duplicar periodos ni eliminar aquellos que estén asignados a alguna materia u oferta académica actual ni del histórico
                </div>
            </Col>
            <Col md ={12} align="justify" className="custom-mt-10">
                <div className="custom-alert-success"><i className="fa fa-graduation-cap"></i> Autoridades Educativas</div>
                <div align="justify" className="custom-mt-10">
                    Aquí puedes agregar a las autoridades educativas de la institución. Para esto haz click en el botón <strong>Agregar</strong>
                    <Row className="custom-mt-10">
                        <Col md={3}>
                            <button className="btn btn-relleno-success btn-xs" style={{borderWidth: 1}}><i className="fa fa-plus"></i> Agregar</button>
                        </Col>
                        <Col md={9} align="justify">
                            Este botón desplegará una ventana, la cual deberás completar con los datos de la persona a agregar.
                            Luego presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-save"></i> Agregar Autoridad</button>
                        </Col>
                        <Col md={3} className="custom-mt-10">
                            <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-gear"></i></button>
                        </Col>
                        <Col md={9} align="justify" className="custom-mt-10">
                            Este botón te desplegara las opciones:
                        </Col>
                            <Col md={5} className="custom-mt-10">
                                <div className="text-warning" style={{fontSize: 11}}><i className="fa fa-edit"></i> Editar Datos</div>
                            </Col>
                            <Col md={7} align="justify" className="custom-mt-10">
                                Despliega una ventana con los datos de la Autoridad Educativa para poder editarlos 
                            </Col>
                            <Col md={5} className="custom-mt-10">
                                <div className="text-danger" style={{fontSize: 11}}><i className="fa fa-trash"></i> Eliminar Datos</div>
                            </Col>
                            <Col md={7} align="justify" className="custom-mt-10">
                                Elimina la Autoridad de la Base de Datos <strong style={{fontSize:10}}>(Esta opción no puede deshacerse)</strong>
                            </Col>
                    </Row>
                </div>
            </Col>
            <Col md ={12} align="justify" className="custom-mt-10">
                <div className="custom-alert-warning"><i className="fa fa-gear"></i> Configuraciones del Sistema</div>
                <div align="justify" className="custom-mt-10">
                    Completa todos los campos y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-save"></i> Guardar</button>
                </div>
                <div className="text-danger custom-mt-10" style={{fontSize: 12}}><i class="fa fa-pie-chart"></i> Distribución del Porcentaje</div>
                <div style={{fontSize: 12}}>
                    En esta sección debes seleccionar los cortes de notas disponibles, también debes indicar el porcentaje de cada uno tomando en cuenta que el total debe ser 100
                </div>
                <div className="text-danger custom-mt-10" style={{fontSize: 12}}><i class="fa fa-check-circle"></i> Cortes de Nota Habilitados para los Profesores</div>
                <div style={{fontSize: 12}}>
                    En esta sección podrás <Switch height={12} width={24} onChange={this.cambiaCkeckP()} checked={true} /> <strong>habilitar</strong> y <Switch height={12} width={24}  onChange={this.cambiaCkeckP()} checked={false} /> <strong>deshabilitar</strong> los cortes de nota para que los profesores puedan cargar cada corte.
                </div>
                <div className="text-danger custom-mt-10" style={{fontSize: 12}}><i class="fa fa-list"></i> Ordenar Listados</div>
                <div style={{fontSize: 12}}>
                    En esta sección puedes establecer el orden de todos los listados de estudiantes
                </div>
            </Col>
        </Row>
    )

    render() {
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Preferencias</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modal()}
                {this.delPeriodo()}
            </div>
        );
    }
}
 
export default Preferencias;


// WEBPACK FOOTER //
// ./src/views/Registros/Preferencias.jsx